<template>
  <nav>
    <v-snackbar :color="$store.state.snackbarColor" v-model="$store.state.snackbar" :timeout="3000" top>
      <span>{{ $store.state.snackbarText }}</span>
      <v-btn text color="white" @click="$store.commit('setSnackbar', false)">
        <v-icon class="white--text">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>

    <v-app-bar app>
      <v-app-bar-nav-icon class="grey--text" @click="$store.commit('setDrawer', !$store.state.drawer)"></v-app-bar-nav-icon>

      <v-toolbar-title class="grey--text">
        <span class="font-weight-light pointer" @click="$router.push('/')">ContinYou</span>
        <span class="pointer headerTitleColor" @click="$router.push('/')">Logistics</span>
        <span class="font-weight-light"> - {{ $route.name }}</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>
    </v-app-bar>
  </nav>
</template>

<script>
export default {
  name: 'Navbar'
}
</script>

<style>
.navbarActive {
  background-color: teal;
}

.pointer {
  cursor: pointer;
}

.headerTitleColor {
  color: #004545;
}
</style>
